import { Directive, TemplateRef, Input } from '@angular/core';


@Directive({
    selector: '[mkt-carousel-slide]',
    standalone:false
})
export class MktCarouselItemDirective {

    isActiveSlide: boolean = false;

    @Input('carouselSlide') slideAnnounce: string;

    constructor(public tpl: TemplateRef<any>) {}

}